import type {TrackDispatcher} from '@gaia/hooks/useTracks';
import compact from 'lodash/compact';
import keyBy from 'lodash/keyBy';

function isTrackPoint(point: Waypoint | TrackPoint): point is TrackPoint {
    return Boolean(point.properties.trackLocalId);
}

export default function (
    action: UpdateWaypointAction,
    setWaypoints: React.Dispatch<React.SetStateAction<{[localId: string]: Waypoint}>>,
    trackPoints: {[localId: string]: Waypoint},
    trackDispatcher: TrackDispatcher
) {
    const data = Array.isArray(action.data) ? action.data : [action.data];
    const trackWaypoints: TrackPoint[] = compact(
        data.map((point) => {
            if (isTrackPoint(point)) return point;
            return undefined;
        })
    );
    const points: Waypoint[] = compact(
        data.map((point) => {
            if (!isTrackPoint(point)) return point;
            return undefined;
        })
    );

    // This is only invoked when a route waypoint is edited. Since its geometry cannot be
    // edited directly we only need to update the properties
    if (trackWaypoints[0]) {
        return trackDispatcher({
            type: 'updatePointProperties',
            properties: trackWaypoints[0].properties,
        });
    }

    setWaypoints((latestWaypoints) => ({
        ...latestWaypoints,
        ...keyBy(points, (waypoint) => waypoint.properties.localId),
    }));

    return points.map((point) => point.properties.localId);
}
